var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"translation-mode-toggle",class:{active: _vm.editMode},on:{"click":_vm.toggleEditMode}},[_c('FaIcon',{attrs:{"icon":_vm.icon,"size":"2x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }